import { render, staticRenderFns } from "./risk_assessments.vue?vue&type=template&id=60eb6fe4&"
import script from "./risk_assessments.vue?vue&type=script&lang=js&"
export * from "./risk_assessments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports